import { epicRequest } from 'app'

export const SEARCH_TOURNAMENTS_FETCH = 'SEARCH_TOURNAMENTS_FETCH'
export const SEARCH_TOURNAMENTS_FETCH_ERROR = 'SEARCH_TOURNAMENTS_FETCH_ERROR'
export const SEARCH_TOURNAMENTS_FETCH_FULFILLED = 'SEARCH_TOURNAMENTS_FETCH_FULFILLED'
export const SEARCH_TOURNAMENTS_FETCH_CANCELED = 'SEARCH_TOURNAMENTS_FETCH_CANCELED'

export const SEARCH_INSTITUTIONS_FETCH = 'SEARCH_INSTITUTIONS_FETCH'
export const SEARCH_INSTITUTIONS_FETCH_ERROR = 'SEARCH_INSTITUTIONS_FETCH_ERROR'
export const SEARCH_INSTITUTIONS_FETCH_FULFILLED = 'SEARCH_INSTITUTIONS_FETCH_FULFILLED'
export const SEARCH_INSTITUTIONS_FETCH_CANCELED = 'SEARCH_INSTITUTIONS_FETCH_CANCELED'

export const SEARCH_FOLLOWS_FETCH = 'SEARCH_FOLLOWS_FETCH'
export const SEARCH_FOLLOWS_FETCH_ERROR = 'SEARCH_FOLLOWS_FETCH_ERROR'
export const SEARCH_FOLLOWS_FETCH_FULFILLED = 'SEARCH_FOLLOWS_FETCH_FULFILLED'
export const SEARCH_FOLLOWS_FETCH_CANCELED = 'SEARCH_FOLLOWS_FETCH_CANCELED'

export const SEARCH_INITIAL_STATE = {
  error: null,
  institutions: null,
  teams: null,
  tournaments: null,
}

export const searchFollowsFetch = () => ({
  payload: {},
  type: SEARCH_FOLLOWS_FETCH,
})

export const searchFollowsFetchFulfilled = (payload) => ({
  payload,
  type: SEARCH_FOLLOWS_FETCH_FULFILLED,
})

export const searchFollowsFetchCanceled = () => ({
  payload: null,
  type: SEARCH_FOLLOWS_FETCH_CANCELED,
})

export const searchFollowsFetchError = (payload) => ({
  payload,
  type: SEARCH_FOLLOWS_FETCH_ERROR,
})

export const searchFollowsFetchEpic = epicRequest({
  actionType: SEARCH_FOLLOWS_FETCH,
  errorAction: searchFollowsFetchError,
  fulfilledAction: searchFollowsFetchFulfilled,
  request: 'user/following',
  untilTypes: SEARCH_FOLLOWS_FETCH_CANCELED,
})

export const searchTournamentsFetch = () => ({
  payload: {},
  type: SEARCH_TOURNAMENTS_FETCH,
})

export const searchTournamentsFetchFulfilled = (payload) => ({
  payload,
  type: SEARCH_TOURNAMENTS_FETCH_FULFILLED,
})

export const searchTournamentsFetchCanceled = () => ({
  payload: null,
  type: SEARCH_TOURNAMENTS_FETCH_CANCELED,
})

export const searchTournamentsFetchError = (payload) => ({
  payload,
  type: SEARCH_TOURNAMENTS_FETCH_ERROR,
})

export const searchTournamentsFetchEpic = epicRequest({
  actionType: SEARCH_TOURNAMENTS_FETCH,
  errorAction: searchTournamentsFetchError,
  fulfilledAction: searchTournamentsFetchFulfilled,
  request: 'sports/tournaments/active',
  untilTypes: SEARCH_TOURNAMENTS_FETCH_CANCELED,
})

export const searchInstitutionsFetch = () => ({
  payload: {},
  type: SEARCH_INSTITUTIONS_FETCH,
})

export const searchInstitutionsFetchFulfilled = (payload) => ({
  payload,
  type: SEARCH_INSTITUTIONS_FETCH_FULFILLED,
})

export const searchInstitutionsFetchCanceled = () => ({
  payload: null,
  type: SEARCH_INSTITUTIONS_FETCH_CANCELED,
})

export const searchInstitutionsFetchError = (payload) => ({
  payload,
  type: SEARCH_INSTITUTIONS_FETCH_ERROR,
})

export const searchInstitutionsFetchEpic = epicRequest({
  actionType: SEARCH_INSTITUTIONS_FETCH,
  errorAction: searchInstitutionsFetchError,
  fulfilledAction: searchInstitutionsFetchFulfilled,
  request: 'institutions',
  untilTypes: SEARCH_INSTITUTIONS_FETCH_CANCELED,
})
